export default {
  'cardAdministrators.domain.name': 'Nome',
  'cardAdministrators.domain.cnpj': 'CNPJ',
  'cardAdministrators.domain.stateRegistration': 'Registro Estadual',

  'cardAdministrators.create': 'Criar Administradora de Cartão',
  'cardAdministrators.create.notification.success': 'Sucesso',
  'cardAdministrators.create.notification.successDescription':
    'Administradora de cartão criada.',

  'cardAdministrators.update': 'Editar Administradora de Cartão',
  'cardAdministrators.update.notification.success': 'Sucesso',
  'cardAdministrators.update.notification.successDescription':
    'Administradora de cartão editada.',

  'cardAdministrators.remove': 'Remover Administradora de Cartão',
  'cardAdministrators.remove.alert':
    'Você realmente deseja remover a administradora de cartão:',
  'cardAdministrators.remove.notification.success': 'Sucesso',
  'cardAdministrators.remove.notification.successDescription':
    'Administradora de Cartão removida.',

  'cardAdministrators.generateReport': 'Gerar Relatório',
};
